import { SubmissionError } from '#helper/submission-error';
import { webPortalApi } from '#config/web-portal-api';
import { snackBarError, fetchAdditions } from '#action/fetch';
import { FETCH_SHIPMENT_NOTIFICATION_RECIPIENTS } from '#action/types';
import { getRequestOptions } from '#helper';

export const fetchShipmentNotificationRecipients = id =>
  dispatch =>
    dispatch(fetchAdditions(`shipment/${id}/notification`, FETCH_SHIPMENT_NOTIFICATION_RECIPIENTS));

export const putShipmentNotificationRecipients = (id, recipients) => async dispatch => {
  const res = await fetch(webPortalApi.buildApiUrl(`shipment/${id}/notification`), {
    method: 'PUT',
    body: JSON.stringify(recipients),
    ...getRequestOptions()
  });
  const response = await res.json();

  if (!res.ok) {
    dispatch(
      snackBarError({
        message: 'Error in request',
        ...response
      })
    );
    throw new SubmissionError(response);
  }

  return { success: true };
};
